exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toast---2L2-i{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;position:fixed;bottom:77px;left:0;width:100%;visibility:visible;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-top:15px;padding-bottom:15px;opacity:0;-webkit-animation:fadeIn---s7cFb 7s;animation:fadeIn---s7cFb 7s;font-size:17px;z-index:2147483647}.message---2WI7-{color:#fff}@-webkit-keyframes fadeIn---s7cFb{0%{opacity:0}25%{opacity:1}75%{opacity:1}100%{opacity:0}}@keyframes fadeIn---s7cFb{0%{opacity:0}25%{opacity:1}75%{opacity:1}100%{opacity:0}}", ""]);

// exports
exports.locals = {
	"toast": "toast---2L2-i",
	"fadeIn": "fadeIn---s7cFb",
	"message": "message---2WI7-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/toast/index.scss
// module id = 726
// module chunks = 3